module.exports = __webpack_public_path__ + "static/banner-2f1f50b4c11a8a51f1d5832f2652444a.jpg";